'use strict';

module.exports = function () {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.indexOf('ucbrowser') >= 0) {
    return true;
  }
  return false;
};